import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { utcMoment } from '../helpers/moment-utils';

@Injectable()
export class UtcDateAdapter extends NativeDateAdapter {
  override parse(value: any): Date | null {
    return utcMoment(value).toDate();
  }

  override format(date: Date): string {
    return utcMoment(date, true).format('YYYY-MM-DD');
  }

  override createDate(year: number, month: number, date: number): Date {
    return utcMoment()
      .set({ year, month, date, hour: 0, minute: 0, second: 0, millisecond: 0 })
      .toDate();
  }

  override getDate(date: Date): number {
    return utcMoment(date, true).date();
  }

  override getMonth(date: Date): number {
    return utcMoment(date, true).month();
  }

  override getYear(date: Date): number {
    return utcMoment(date, true).year();
  }

  override getDayOfWeek(date: Date): number {
    return utcMoment(date, true).day();
  }

  override getNumDaysInMonth(date: Date): number {
    return utcMoment(date, true).daysInMonth();
  }
}
